import {
  AccountContact,
  AccountContactType
} from "@/components/Contracts/ConfirmationStep/Signature/signature.interface";

export const isFirstRequiredContact = (
  fieldValue: AccountContact,
  values: Array<AccountContact>,
  index: number,
  requiredContactTypes: Array<AccountContactType>
) => {
  if (!requiredContactTypes.includes(fieldValue?.contactType)) {
    return false;
  }

  return (
    values.findIndex(
      contact => contact.contactType === fieldValue.contactType
    ) === index
  );
};
